import React, { useEffect, useState } from 'react'
import { Contact, Group, NonDeletedIds } from '../../models/conversations'
import { ColDef, ColumnApi, GridApi, ValueGetterParams } from 'ag-grid-community';
import GridComponent from "../shared/grid";
import { AppState } from '../../reducers/models';
import { connect } from 'react-redux';
import {  } from 'react-router-dom';
import { BackMobileIcon } from '../../icon';
import { AppRoutes } from '../routes/route.path';
import { Chip } from '@mui/material';
import { UtilityService } from '../../services/UtilityService';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as selector from '../../selectors/selectors'




interface IProps {
    NonDeletedContacts?: NonDeletedIds[];
}
const GroupDeletionInfo = (props: IProps) => {
    const dispatch = useDispatch()
    const Groups: Group[] = useSelector(selector.groups);
    const Contacts: Contact[] = useSelector(selector.contacts);
    const GroupContactsDeletionData: any = useSelector(selector.groupContactsDeletionData);
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);

    const [gridApi, setGridApi] = useState<GridApi>(null)
    const [columnApi, setColumnApi] = useState<ColumnApi>(null)

    const GroupDeletionColomunDefs: ColDef[] = [
        {
            field: "",
            headerName: "S.No",
            valueGetter: (params: ValueGetterParams) => {
                return params.node.rowIndex + 1
            },
            maxWidth: IsMobileDevice ? 60 : 100,
            hide: IsMobileDevice,
        },
        {
            field: "ContactId",
            headerName: "Contact Name",
            valueGetter: (params: ValueGetterParams) => {
                const contactName = Contacts?.find((y) => y.ID === params.data.contactId)?.Name
                return contactName
            },
            // cellStyle: !props.IsMobileDevice ? { textOverflow: 'ellipsis' } : null
        },
        {
            field: "GroupIds",
            headerName: "Group Name",
            autoHeight: true,
            wrapText: true,
            cellRenderer: (params) => {
                const GroupName = params.data.groupIds?.map((y) => Groups?.find((z) => z.ID === y)?.Name)
                return <div>
                    {GroupName.map(x =>
                        <Chip
                            className={"ml-1 mb-1 custom-color-chip-1"}
                            label={UtilityService.trimMessage(x, 17)}
                        />)}
                </div>
            }
        }

    ]

    const onGridReady = (params) => {
        setGridApi(params.api);
        setColumnApi(params.columnApi)
    }
    return (
        <div className={`${!IsMobileDevice ? "h-v-48" : "h-v-40"} bg-color-secondary o-y-scroll mt-1 mx-auto`}>
            <GridComponent
                ColumnDefs={GroupDeletionColomunDefs}
                RowData={GroupContactsDeletionData.nonDeletedContacts}
                OnGridReady={onGridReady}
                IsPaginationEnabled={false}
                EmptyLabel={''}
                LockVisible={true} />
        </div>
    )
}

export default GroupDeletionInfo
